export default __webpack_public_path__ + "static/media/clapperboard.5243450b.png";